import React, { useContext } from "react";
import { Card, Table, Badge } from "@themesberg/react-bootstrap";
import Pagination from "../../../../components/Pagination";
import { Context } from "../TransactionHistory";
import { getWalletLabel, WALLET_MAIN } from "../../../../helper/wallet";
import { describeMoneyLog } from "../../../../helper/moneyLogDescription";

const formatDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value)
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const TableRow = ({ entry }) => {
  const amount = Number(entry.commitedAmount) || 0
  const isCredit = amount >= 0
  const detail = describeMoneyLog(entry.description, entry.wallet, amount)

  return (
    <tr>
      <td className="text-center">{formatDateTime(entry.createdAt)}</td>
      <td>
        {entry.name || ''}<br />
        <strong className="text-primary">{entry.phone || ''}</strong>
      </td>
      <td className="text-center">
        <Badge bg={entry.wallet === WALLET_MAIN ? 'info' : 'warning'} className="px-3 py-2 fw-normal">
          {getWalletLabel(entry.wallet)}
        </Badge>
      </td>
      <td className={`text-center fw-bold ${isCredit ? 'text-success' : 'text-danger'}`}>
        {isCredit ? '+' : ''}{new Intl.NumberFormat('vi-VN').format(amount)}
      </td>
      <td>
        <div>{detail.label}</div>
        {detail.reference && <div className="small text-muted">Mã: {detail.reference}</div>}
      </td>
    </tr>
  );
};

const _Table = () => {
  const { state, dispatch } = useContext(Context);

  return (
    <Card border="light" className="shadow-sm mb-4 border-0">
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table className="table-centered table-nowrap mb-0 rounded align-middle" hover>
            <thead className="bg-white border-bottom">
              <tr>
                <th className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted">Thời gian</th>
                <th className="border-bottom py-3 text-uppercase small fw-bold text-muted">Khách hàng</th>
                <th className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted">Ví</th>
                <th className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted">Số tiền</th>
                <th className="border-bottom py-3 text-uppercase small fw-bold text-muted">Nội dung</th>
              </tr>
            </thead>
            <tbody>
              {state.data.list && state.data.list.map((entry) => (
                <TableRow key={`money-log-${entry.wallet}-${entry.id}`} entry={entry} />
              ))}
              {(!state.data.list || state.data.list.length === 0) && (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-muted">
                    <div className="fs-5">Chưa có dữ liệu</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
      <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <div className="fw-normal small mt-1 mt-lg-0 text-muted">
          Hiển thị <b>{state.data.list?.length || 0}</b> trong tổng{" "}
          <b>{state.data.total || 0}</b> giao dịch
        </div>
        <Pagination
          totalPage={state.data.totalPage || 0}
          currentPage={state.filter.page || 0}
          onPageChange={(i) => {
            dispatch({
              type: "UPDATE_PAGE",
              payload: i,
            });
          }}
        />
      </Card.Footer>
    </Card>
  );
};

export default React.memo(_Table)
